import React from 'react';

export const FormEditorIconActive = () => {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6426 0.000976562V9.14258H20.7852V21.7139C20.7852 22.9762 19.7614 24 18.499 24H2.49902C1.23672 23.9999 0.213867 22.9762 0.213867 21.7139V2.28613C0.213867 1.02381 1.23672 7.53193e-05 2.49902 0H11.6416L11.6426 0.000976562ZM4.78516 18.2861H16.2139V17.1426H4.78516V18.2861ZM4.78516 14.8574H16.2139V13.7139H4.78516V14.8574ZM13.9277 2.28613L16.2139 4.57129L19.6426 8H12.7852V1.14355L13.9277 2.28613Z"
        fill="#065B74"
      />
    </svg>
  );
};

export const FormEditorIconInactive = () => {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.2851 9.14286H11.8565V1.71429H2.14226V22.2857H19.2851V9.14286ZM11.8565 0L14.1423 2.28571L16.428 4.57143L17.5708 5.71429L20.9994 9.14286V21.7143C20.9994 22.9767 19.9761 24 18.7137 24H2.71369C1.45133 24 0.427979 22.9767 0.427979 21.7143V2.28571C0.427979 1.02335 1.45133 0 2.71369 0H11.8565Z"
        fill="#065B74"
      />
      <rect x="4.99976" y="13.7139" width="11.4286" height="1.14286" fill="#065B74" />
      <rect x="4.99976" y="17.1426" width="11.4286" height="1.14286" fill="#065B74" />
    </svg>
  );
};

export const ConfirmationPageIconActive = () => {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8569 0.000976562V9.14258H20.9995V21.7139C20.9995 22.9762 19.9757 24 18.7134 24H2.71338C1.45108 23.9999 0.428223 22.9762 0.428223 21.7139V2.28613C0.428223 1.02381 1.45108 7.53193e-05 2.71338 0H11.856L11.8569 0.000976562ZM9.13721 17.6562L5.68896 14.209L4.99951 14.8984L9.13721 19.0371L9.82764 18.3477L9.82666 18.3467L16.0337 12.1396L15.3442 11.4492L9.13721 17.6562ZM14.1421 2.28613L16.4282 4.57129L19.8569 8H12.9995V1.14355L14.1421 2.28613Z"
        fill="#065B74"
      />
    </svg>
  );
};

export const ConfirmationPageIconInactive = () => {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.071 9.14286H11.6424V1.71429H1.92815V22.2857H19.071V9.14286ZM11.6424 0L13.9282 2.28571L16.2139 4.57143L17.3567 5.71429L20.7853 9.14286V21.7143C20.7853 22.9767 19.7619 24 18.4996 24H2.49958C1.23722 24 0.213867 22.9767 0.213867 21.7143V2.28571C0.213867 1.02335 1.23722 0 2.49958 0H11.6424Z"
        fill="#065B74"
      />
      <path
        d="M8.92284 17.6564L15.13 11.4492L15.8199 12.1391L9.61268 18.3463L9.61337 18.347L8.92353 19.0368L4.78516 14.8984L5.475 14.2086L8.92284 17.6564Z"
        fill="#065B74"
      />
    </svg>
  );
};

export const EmailIconActive = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.125 3H1.875C0.84375 3 0 3.84375 0 4.875V19.875C0 20.9062 0.84375 21.75 1.875 21.75H23.125C24.1562 21.75 25 20.9062 25 19.875V4.875C25 3.84375 24.1562 3 23.125 3ZM22.4062 4.5625L13.1313 14.725C12.925 14.95 12.6375 15.0813 12.3312 15.0813C12.0187 15.0813 11.7375 14.9625 11.525 14.7375L1.9875 4.5625H22.4062Z"
        fill="#065B74"
      />
    </svg>
  );
};

export const EmailIconInactive = () => {
  return (
    <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.125 0H1.875C0.84375 0 0 0.84375 0 1.875V16.875C0 17.9062 0.84375 18.75 1.875 18.75H23.125C24.1562 18.75 25 17.9062 25 16.875V1.875C25 0.84375 24.1562 0 23.125 0ZM22.4062 1.5625L13.1313 11.725C12.925 11.95 12.6375 12.0813 12.3312 12.0813C12.0187 12.0813 11.7375 11.9625 11.525 11.7375L1.9875 1.5625H22.4062ZM23.125 17.1875H1.875C1.7 17.1875 1.5625 17.05 1.5625 16.875V3.39375L10.3875 12.8062C10.8875 13.3375 11.5938 13.6438 12.325 13.6438H12.3438C13.0813 13.6438 13.7875 13.325 14.2875 12.7812L23.4375 2.75V16.875C23.4375 17.05 23.3 17.1875 23.125 17.1875Z"
        fill="#065B74"
      />
    </svg>
  );
};

export const RocketIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#0B99C2" />
      <circle cx="18" cy="18" r="18" stroke="#D9EDF3" />
      <path
        d="M21.7661 20.6556L24.3927 18.6866C27.5061 16.3503 28.8843 11.6391 28.1881 7.81162C24.3593 7.11548 19.6481 8.49364 17.3131 11.607L15.3441 14.2336M21.7661 20.6556L17.2707 23.8666L12.1331 18.729L15.3441 14.2336M21.7661 20.6556V24.0811C21.7661 25.1928 21.4056 26.2744 20.7386 27.1637L19.8395 28.362L18.5551 27.0776M15.3441 14.2336H11.9186C10.807 14.2336 9.72534 14.5942 8.83604 15.2611L7.6377 16.1602L8.9221 17.4446M13.4175 25.7932L8.9221 27.0776L10.4197 22.5822M22.4083 14.8758C22.7489 14.8758 23.0756 14.7405 23.3165 14.4996C23.5574 14.2588 23.6927 13.9321 23.6927 13.5914C23.6927 13.2508 23.5574 12.9241 23.3165 12.6832C23.0756 12.4423 22.7489 12.307 22.4083 12.307C22.0677 12.307 21.741 12.4423 21.5001 12.6832C21.2592 12.9241 21.1239 13.2508 21.1239 13.5914C21.1239 13.9321 21.2592 14.2588 21.5001 14.4996C21.741 14.7405 22.0677 14.8758 22.4083 14.8758Z"
        fill="#0B99C2"
      />
      <path
        d="M21.7661 20.6556L24.3927 18.6866C27.5061 16.3503 28.8843 11.6391 28.1881 7.81162C24.3593 7.11548 19.6481 8.49364 17.3131 11.607L15.3441 14.2336M21.7661 20.6556L17.2707 23.8666L12.1331 18.729L15.3441 14.2336M21.7661 20.6556V24.0811C21.7661 25.1928 21.4056 26.2744 20.7386 27.1637L19.8395 28.362L18.5551 27.0776M15.3441 14.2336H11.9186C10.807 14.2336 9.72534 14.5942 8.83604 15.2611L7.6377 16.1602L8.9221 17.4446M13.4175 25.7932L8.9221 27.0776L10.4197 22.5822M22.4083 14.8758C22.7489 14.8758 23.0756 14.7405 23.3165 14.4996C23.5574 14.2588 23.6927 13.9321 23.6927 13.5914C23.6927 13.2508 23.5574 12.9241 23.3165 12.6832C23.0756 12.4423 22.7489 12.307 22.4083 12.307C22.0677 12.307 21.741 12.4423 21.5001 12.6832C21.2592 12.9241 21.1239 13.2508 21.1239 13.5914C21.1239 13.9321 21.2592 14.2588 21.5001 14.4996C21.741 14.7405 22.0677 14.8758 22.4083 14.8758Z"
        stroke="#D9EDF3"
        stroke-width="2.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="46" cy="46" r="46" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.2393 25.5977C90.2869 31.7459 92 38.6729 92 46C92 71.4051 71.4051 92 46 92C20.5949 92 0 71.4051 0 46C0 20.5949 20.5949 0 46 0C57.7364 0 68.4462 4.39529 76.5732 11.6296L43.2285 50.255L29.4458 36.4722C26.0935 33.12 20.6022 33.12 17.25 36.4722C13.8977 39.8302 13.8977 45.3158 17.25 48.6738L37.582 69C40.9342 72.3522 46.4198 72.3522 49.7778 69L87.2393 25.5977Z"
        fill="#333333"
      />
    </svg>
  );
};
